import type { VoidFunctionComponent } from 'react';

import { LabeledSelect } from '../../generic';
import { useReportFormatSelector } from '../hooks/useFormatSelector';
import type { AnyReportFormatOption } from '../types';

import styles from './FormatSelector.module.less';

/**
 * Dropdown which allows the user to select the format of the report.
 * When only one format is available (e.g. Vulnerability — PDF only), the
 * dropdown is rendered disabled so users can still see the format but cannot
 * change it.
 */
export const FormatSelector: VoidFunctionComponent = () => {
  const { options, value, setFormat } = useReportFormatSelector();
  const isLocked = options.length <= 1;
  return (
    <div className={styles.formatSelector}>
      <LabeledSelect<AnyReportFormatOption>
        id="report-format"
        label="Format"
        value={value}
        options={options}
        onChange={setFormat}
        isDisabled={isLocked}
      />
    </div>
  );
};
